module.exports = __webpack_public_path__ + "static/media/img-groc-background.e027419c.png";